import ArrowButtonRightIcon from '@/components/Common/Icons/ArrowButtonDownIcon';
import TransferIcon from '@/components/Common/Icons/TransferIcon';
import { useQueryParams } from '@/shared/hooks';
import { SupplierProfileProductsSort } from '@/shared/types/sourcing-marketplace';
import { ParamKey } from '@/shared/types/url-params';
import { Dropdown, MenuProps, Space } from 'antd';
import { cloneElement, useEffect, useState } from 'react';
import './index.less';

const SortFilter = () => {
  const { queryParams, setQueryParams } = useQueryParams<{}>();
  const sort = queryParams.get(ParamKey.SORT) ?? SupplierProfileProductsSort.FEATURED;
  const [productsSort, setProductSort] = useState<SupplierProfileProductsSort>();
  const menuText = {
    [SupplierProfileProductsSort.FEATURED]: 'Featured',
    [SupplierProfileProductsSort.NEW]: 'Newest',
  };
  const sortMenus: MenuProps['items'] = [
    {
      key: 'sort',
      type: 'group',
      label: 'SORT BY',
      children: [
        {
          key: SupplierProfileProductsSort.FEATURED,
          label: <p className="sort-dropdown-item">{menuText[SupplierProfileProductsSort.FEATURED]}</p>,
        },
        {
          key: SupplierProfileProductsSort.NEW,
          label: <p className="sort-dropdown-item">{menuText[SupplierProfileProductsSort.NEW]}</p>,
        },
      ],
    },
  ];

  useEffect(() => {
    setProductSort(sort as SupplierProfileProductsSort);
  }, [sort]);

  return (
    <div className="sourcing-sort-filter-box">
      <Dropdown
        className="sort-dropdown"
        menu={{
          items: sortMenus,
          onClick: ({ key }) => {
            setProductSort(key as SupplierProfileProductsSort);
            setQueryParams({ [ParamKey.SORT]: key });
          },
        }}
        dropdownRender={(menu) => <div className="sort-dropdown-items">{cloneElement(menu as React.ReactElement)}</div>}
      >
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            <TransferIcon />
            <span className="selected-sort">{menuText[productsSort]}</span>
            <ArrowButtonRightIcon className="arrow-down-svg" fill="#6B6B6B" />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
};

export default SortFilter;
